import instance from './apiHeader'
import BaseURL from './baseURL'

const checkMaintenance = async () => {
  if(process.env.NODE_ENV === 'production') return await instance.get(BaseURL.appURL() + `/health/Maintenance`)
}

const fetchLogPii = async (data) => {
  return await instance.get(BaseURL.appURL() + `/config/piiLog/${data?.startDate}/${data?.endDate}`)
}

const fetchGenerateLogPii = async () => {
  return await instance.get(BaseURL.appURL() + `/config/piiLogGenerate`)
}

const generateLogPii = async () => {
  return await instance.post(BaseURL.appURL() + `/config/piiLogGenerate`)
}

const configApi = { checkMaintenance, fetchLogPii, fetchGenerateLogPii, generateLogPii }

export default configApi
